module.exports = {
	"articleTitle1": "Michigan rolls Buckeyes on Senior Night ",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "Canham Natatorium",
	"articleLink2": "https://www.michigandaily.com/section/womens-swimming-and-diving/michigan-divers-murphy-mccaffrey-and-hayden-head-ncaas1",
	"articleSnippet1": "Jan 29, 2017 ... Junior Clara Smiddy won both of her events, as Michigan defeated the Buckeyes \nat Canham Natatorium. Haley McLaughlin/Daily. Tien Le.",
	"articleSnippet2": "Mar 12, 2017 ... A diver competes at the Women's Swimming Big 10 Championships at Canham \nNatatorium on February 20, 2016. Amelia Cacchione/Daily.",
	"totalMisc": 0,
	"articleTitle2": "Michigan divers Murphy, McCaffrey and Hayden head to NCAAs ...",
	"address": "2250 S State St. Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160412/msg.NEW_.vsmichiganstate.2.5.16.722.jpg?itok=Msbm9QAZ",
			"author": "Maize Hyams",
			"caption": "Sophomore Emily Kopas dives in to swim breaststroke at a meet against Michigan State at Canham Natatorium on February 6, 2016."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160412/msg.online.jpg?itok=eU-wxw9v",
			"author": "Maize Hyams",
			"caption": "Freshman Collin DeShaw dives at a swim meet against Michigan State at Canham Natatorium on February 6, 2016."
		}
	],
	"position": {
		"lat": 42.2693,
		"lng": -83.7438
	},
	"tips": [],
	"articleLink1": "https://www.michigandaily.com/section/womens-swimming-and-diving/wolverines-beat-ohio-state-senior-night",
	"categories": {
		"misc": 1,
		"location": 1,
		"athleticfacility": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/canhamnatatorium.json
// module id = 842
// module chunks = 0